(() => {
  const nmT = (key, fallback, vars) => {
    let s = (window.NM_I18N && window.NM_I18N[key]) || fallback;
    if (vars) for (const k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  };

  const enhanceContribe = () => {
    const selector = document.querySelector('#contribe-selector');
    if (!selector) return;

    // The app currently injects a second <main>. An explicit labelled region prevents a
    // duplicate-main landmark without rewriting app-owned DOM.
    selector.setAttribute('role', 'region');
    selector.setAttribute('aria-label', nmT('donation_select', 'Vælg donationsprojekt'));

    selector.querySelectorAll('button').forEach((button, index) => {
      const hasName = button.getAttribute('aria-label')
        || button.getAttribute('aria-labelledby')
        || button.textContent.trim();
      if (hasName) return;

      const mediaName = button.querySelector('img[alt]')?.alt?.trim()
        || button.querySelector('[title]')?.getAttribute('title')?.trim();
      button.setAttribute('aria-label', mediaName || nmT('donation_select_n', 'Vælg donationsprojekt {number}', { number: index + 1 }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContribe, { once: true });
  } else {
    enhanceContribe();
  }

  const observer = new MutationObserver(enhanceContribe);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
